import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueClipboard from 'vue-clipboard2';
import VueContextMenu from 'vue-contextmenu'
import ViewUI from "view-design";
import { dateStr, formatDateTime } from "./utils/ChatUtils.js";
import "view-design/dist/styles/iview.css";
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import "@/static/styles/font.css";

Vue.use(VueVideoPlayer);

Vue.use(ViewUI);	
Vue.use(VueClipboard);
Vue.use(VueContextMenu);
Vue.use(preview);	//图片预览

Vue.config.productionTip = false;

Vue.prototype.formatDateTime = formatDateTime;
Vue.prototype.dateStr = dateStr;
if (process.env.VUE_APP_MODE === "web") {
  Vue.prototype.winControl = require("@/mode/webControl").default;
} else {
  Vue.prototype.winControl = require("@/mode/windowControl").default;
}

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
